<template>
  <div class="card p-6 mb-2 mt-3">
    <div class="d-flex px-4 mb-2" style="gap: 16px">
      <b-form-group label="Country Manager" class="widthEditFieldPartner">
        <CountrymanagerSucheMultiselect
          v-model="editedSeason.countryManagerKuerzel"
          :isMultipleAllowed="true"
          :isChangedMetadata="changedFields.includes('countryManagerKuerzel')"
        />
        <div v-if="countryManagerGeleert" class="country-manager-hinweis" role="alert">
          <CircleAlert :size="14" class="flex-shrink-0" />
          <span>
            Die Country Manager können nicht entfernt werden, es muss mindestens einer gesetzt bleiben.
          </span>
        </div>
      </b-form-group>
      <b-form-group label="Weitere Partner" class="widthEditFieldPartner">
        <CountrymanagerSucheMultiselect
          v-model="editedSeason.weiterePartner"
          placeholder="Weitere Partner suchen…"
          :isMultipleAllowed="true"
          :isChangedMetadata="changedFields.includes('weiterePartner')"
        />
      </b-form-group>
    </div>
    <div class="d-flex px-4 mb-2" style="gap: 16px">
      <b-form-group label="Hotelnächte" class="widthEditField">
        <b-form-input
          :class="{ changed: changedFields.includes('hotelnaechte') }"
          size="sm"
          v-model="editedSeason.hotelnaechte"
          :number="true"
          type="number"
          min="0"
          max="365"
          step="1"
          required
        ></b-form-input>
      </b-form-group>
      <div class="widthEditField">
        <b-form-group label="Vorverlängerung">
          <b-input-group size="sm">
            <b-form-input
              :class="{ changed: changedFields.includes('vorverlaengerung') }"
              size="sm"
              v-model.number="editedSeason.vorverlaengerung"
              :number="true"
              type="number"
              min="0"
              @input="validateVorverlaengerung"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="widthEditField">
        <b-form-group label="Erw. Termindurchführungsquote">
          <b-input-group size="sm">
            <b-form-input
              :class="{ changed: changedFields.includes('erwarteteTermindurchfuehrungsquote') }"
              size="sm"
              v-model="editedSeason.erwarteteTermindurchfuehrungsquote"
              :number="true"
              type="number"
            ></b-form-input>
            <template #append>
              <b-input-group-text>%</b-input-group-text>
            </template>
          </b-input-group>
        </b-form-group>
      </div>
    </div>
    <div class="d-flex px-4 mb-2" style="gap: 16px">
      <b-form-group class="widthEditField">
        <template #label>
          <div class="d-flex align-items-center">
            Durchführbare Min Pax
            <b-button
              class="btn-xs btn py-1 px-2 ml-2 justify-content-center align-items-center d-flex"
              v-b-tooltip.hover
              :title="'Theoretische Durchführbarkeit'"
            >
              <Info :size="14" class="m-0 p-0" />
            </b-button>
          </div>
        </template>
        <b-form-input
          size="sm"
          :class="{ changed: changedFields.includes('durchfuehrbareMinPax') }"
          v-model="editedSeason.durchfuehrbareMinPax"
          :number="true"
          type="number"
          min="0"
          max="365"
          step="1"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Min Pax" class="widthEditField">
        <b-form-input
          size="sm"
          :class="{ changed: changedFields.includes('minPax') }"
          v-model="editedSeason.minPax"
          :number="true"
          type="number"
          min="0"
          max="365"
          step="1"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Max Pax" class="widthEditField">
        <b-form-input
          size="sm"
          :class="{ changed: changedFields.includes('maxPax') }"
          v-model="editedSeason.maxPax"
          :number="true"
          type="number"
          min="0"
          max="365"
          step="1"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Kalk Pax" class="widthEditField">
        <b-form-input
          :class="{ changed: changedFields.includes('kalkPax') }"
          size="sm"
          v-model="editedSeason.kalkPax"
          :number="true"
          type="number"
          min="0"
          max="365"
          step="1"
          required
        ></b-form-input>
      </b-form-group>
    </div>
    <div class="d-flex px-4 mb-2" style="gap: 16px">
      <b-form-group label="Vornacht möglich" class="widthEditField">
        <b-form-checkbox
          size="lg"
          v-model="editedSeason.vornachtMoeglich"
          :class="{ changed: changedFields.includes('vornachtMoeglich') }"
        ></b-form-checkbox>
      </b-form-group>
      <div class="widthEditField">
        <b-form-group label="EK kalk. Vornacht DZ p.P.">
          <b-input-group size="sm">
            <b-form-input
              :class="{ changed: changedFields.includes('einkaufspreisVornachtDzProPerson') }"
              size="sm"
              v-model="editedSeason.einkaufspreisVornachtDzProPerson"
              :number="true"
              type="number"
            ></b-form-input>
            <template #append>
              <b-input-group-text>€</b-input-group-text>
            </template>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="widthEditField">
        <b-form-group label="VK kalk. Vornacht DZ p.P.">
          <b-input-group size="sm">
            <b-form-input
              size="sm"
              :disabled="true"
              :number="true"
              type="number"
              :placeholder="`${
                activeMetadata?.vkVornachtDzProPerson
                  ? String(activeMetadata.vkVornachtDzProPerson).replace('.', ',')
                  : '0'
              }€ (${
                activeMetadata?.vkVornachtDzProPerson
                  ? Math.round(activeMetadata.vkVornachtDzProPerson / 10) * 10
                  : '0'
              }€)`"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import CountrymanagerSucheMultiselect from '@/components/common/countrymanager-suche-multiselect.vue';
import { CircleAlert, Info } from 'lucide-vue';

export default {
  name: 'ReisenMetadataCardAllgemein',
  components: {
    CountrymanagerSucheMultiselect,
    CircleAlert,
    Info,
  },
  props: {
    editedSeason: { type: Object, required: true },
    changedFields: { type: Array, default: () => [] },
    activeMetadata: { type: Object, default: null },
    // Die gespeicherten Country Manager wurden alle entfernt, Speichern ist dann gesperrt
    countryManagerGeleert: { type: Boolean, default: false },
  },
  methods: {
    // Verhindert negative Eingaben bei der Vorverlängerung, indem der Wert auf 0 begrenzt wird
    validateVorverlaengerung() {
      if (this.editedSeason.vorverlaengerung < 0) {
        this.editedSeason.vorverlaengerung = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.widthEditField {
  width: 225px;
}
.widthEditFieldPartner {
  width: 260px;
}
.country-manager-hinweis {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: var(--restriktion-keine-abreise-hart-text);
}

:deep(.changed) {
  background-color: #3699ff50;
}
</style>
